module.exports = __webpack_public_path__ + "static/media/saving.1c13e4ad.svg";